<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn
        class="media-control-button"
        v-on="on"
        @click="$emit('change')"
      >
        <v-icon class="icon mdi-play"  v-show="isMediaPaused">{{ localIcons['mdi-play'] }}</v-icon>
        <v-icon v-show="!isMediaPaused">{{ localIcons['mdi-pause']  }}</v-icon>
      </v-btn>
    </template>
    <span>{{isMediaPaused ? $lang.share.play : $lang.share.pause}}</span>
  </v-tooltip>
</template>

<script>

import { mdiPlay, mdiPause} from '@mdi/js'
export default {
  props:['isMediaPaused'],

  data() {
    return {
        localIcons:{
          'mdi-play':mdiPlay,
          'mdi-pause':mdiPause
        }
    }
  }
}
</script>